import { fromJS } from 'immutable'

import { LOCATION_CHANGE } from 'react-router-redux'

import {
  NEXT_STEP,
  EMAIL_CHANGED
} from './constants'


export const initialState = fromJS({
  currentStep: 0,
  email: ''
})


export default function reducer(state = initialState, action) {
  switch(action.type){
    case EMAIL_CHANGED:
      return state.set('email', action.email)
    case NEXT_STEP:
      return state.set('currentStep', 1)
    case LOCATION_CHANGE:
      return initialState
    default:
      return state
  }
}





// WEBPACK FOOTER //
// ./src/scenes/PasswordRecovery/reducer.js